import React from "react";
import { connect } from "react-redux";
import {guardarRecibirInformacion, guardarRecibirConsejos} from "./datos.act";

const mapState = (state) => {
	return {
		editing: state.miPerfil.editingRedes,
		facebook: state.miPerfil.facebook,
		twitter: state.miPerfil.twitter,
		google: state.miPerfil.google,
		instagram: state.miPerfil.instagram,
		recibirConsejos: state.miPerfil.recibirConsejos,
		recibirInformacion: state.miPerfil.recibirInformacion,
		loadRedesSociales: state.miPerfil.loadRedesSociales
	};
};

const mapDispatch = (dispatch) => {
	return {
		setRecibirConsejos: (val) => {
			dispatch(guardarRecibirConsejos(val));
		},
		setRecibirInformacion: (val) =>{
			dispatch(guardarRecibirInformacion(val));
		},
		addEvento: (evento) => {
			dispatch({ "type": "MI_PERFIL_SET_EVENT", "evento": evento});
		}
	};
};

class RedesSociales extends React.Component {

	changeCheckbox = (event) => {
		let id = event.target.id;
		if(id == "informacion")
		{
			if(event.target.checked)
			{
				this.props.setRecibirInformacion(true);
				this.props.addEvento("RecibirInformacion");
			}
			else
			{
				this.props.setRecibirInformacion(false);
			}
		}
		else if(id == "consejos")
		{
			if(event.target.checked)
			{
				this.props.setRecibirConsejos(true);
				this.props.addEvento("RecibirConsejos");
			}
			else
			{
				this.props.setRecibirConsejos(false);
			}
		}

	}

	render() {
		return <div className="col-xs-12">
			<div className="row">
				<div className="col-xs-12">
					<div className="card perfil-card no-pad-bottom">
						<div className="card-header no-border no-margin no-pad-bottom">
							<div className="row">
								<div className="col-xs-6">
									<i><img src={ require("../img/icon-share.svg")} /></i><b>Redes sociales</b>
								</div>
								<div className="col-xs-6">
								 { this.props.loadRedesSociales &&
									<div className="text-right card-actions-btn">
										<a className="orange-btn" data-toggle="modal" data-target="#modal-redes-sociales">Editar <img src={ require("../img/editar-icono.png")} /></a>
									</div>
								 }
								 { !this.props.loadRedesSociales &&
									<div className="text-right card-actions-btn">
										<img src={ require("../img/load_mini.gif") } />
									</div>
								 }
								</div>
								<div className="col-xs-12">
									<hr />
								</div>
								{ this.props.loadRedesSociales &&
								<div>
								<div className="col-xs-12">
									<div className="checkbox-blue" style={{"textAlign":"initial"}}>
										<input id="consejos" type="checkbox" defaultChecked={this.props.recibirConsejos} onChange={this.changeCheckbox}/>
										<label></label>
										<span style={{"margin-top":"-28px"}}>Deseo recibir consejos, tips y noticias relevantes a través de la revista digital Viviendo GNP.</span>
									</div>
									<div className="checkbox-blue" style={{"textAlign":"initial"}}>
										<input id="informacion" type="checkbox" defaultChecked={this.props.recibirInformacion} onChange={this.changeCheckbox}/>
										<label></label>
										<span style={{"margin-top":"-28px"}}>Deseo recibir información sobre los productos de GNP.</span>
									</div>
								</div>
								<div className="col-xs-12 mt-34">
									<div className="row bordered">
										<div className="col-xs-12 col-md-6">
											<p className="text-right">
												<i className="pull-left"><img src={ require("../img/icon-facebook.svg")} /></i>
												<span><b>{this.props.facebook .length > 17 ? this.props.facebook.substring(0, 10) + "..." : this.props.facebook || 'nombre_Usuario'}</b></span>
											</p>
										</div>
										<div className="col-xs-12 col-md-6">
											<p className="text-right">
												<i className="pull-left"><img src={ require("../img/icon-twitter.svg")} /></i>
												<span><b>{this.props.twitter.length > 17 ? this.props.twitter.substring(0, 10) + "..." : this.props.twitter  || 'nombre_Usuario'}</b></span>
											</p>
										</div>
										<div className="col-xs-12 col-md-6">
											<p className="text-right">
												<i className="pull-left"><img src={ require("../img/icon-g.svg")} /></i>
												<span><b>{this.props.google.length > 17 ? this.props.google.substring(0, 10) + "..." : this.props.google  || 'nombre_Usuario'}</b></span>
											</p>
										</div>
										<div className="col-xs-12 col-md-6">
											<p className="text-right">
												<i className="pull-left"><img src={ require("../img/icon-instagram.svg")} /></i>
												<span><b>{this.props.instagram.length > 17 ? this.props.instagram.substring(0, 10) + "..." : this.props.instagram  || 'nombre_Usuario'}</b></span>
											</p>
										</div>
									</div>
								</div>
								</div>
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
}

export default connect(mapState, mapDispatch)(RedesSociales);



// WEBPACK FOOTER //
// ./src/miPerfil/redes.cmpt.js